import { render, staticRenderFns } from "./layer-look-auction.vue?vue&type=template&id=34bd0ad9&scoped=true&"
import script from "./layer-look-auction.vue?vue&type=script&lang=js&"
export * from "./layer-look-auction.vue?vue&type=script&lang=js&"
import style0 from "./layer-look-auction.vue?vue&type=style&index=0&id=34bd0ad9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bd0ad9",
  null
  
)

export default component.exports